/*global ViewController, WebView, moment, Handlebars*/

var dashboardController = new ViewController({
    directory : "views/dashboard",
    title: WebView.tr("menu.dashboard"),
    name: "dashboard",
    route: "dashboard"
}) ;

dashboardController.prepareDataOnEnter = function(data, callback){

    let searches = {
        res_company: { search: {} },
        iz_dashboard_global_settings: { search: {} },
        iz_dashboard_settings: { search: {} },
        iz_custom_screen: {
            search: { type: "dashboard", active: true }, joinFetch: [
                { otherTable: "iz_custom_query", name: "query" }
            ]
        },
        iz_global_settings: { searchFirst: {} },
        iz_user_replace: {
            search: {
                user_replace_id: this.api.currentUser.id,
                date_start : { ope: "<=", value: new Date() },
                date_end : { ope: ">=", value: new Date() }
            },
            joinFetch: [
                {
                    otherTable: "iz_user_list", name: "user", thisField: "user_id", otherField: "id"
                },
                { otherTable : "res_groups_users_rel", name:"groups", thisField: "user_id", otherField: "uid", type:"2many", joins: [
                    { otherTable : "ir_model_data", name:"model", thisField: "gid", otherField: "res_id", type:"2one", innerJoin:true,
                        joinSearch: {                
                            $or: [
                                { name: "group_iz_doc_module_user" },
                                { name: "group_iz_dinvoice_supplier_user" }
                            ]
                        }
                    }
                ]}
            ]
        },
    } ;
    if(this.api.currentUser.rights.group_iz_doc_fetchmail_admin){
        searches.iz_doc_mail_server = { 
            search: { 
                active: true,
                $and: [
                    {error_message: { ope: "<>", value: null}},
                    {error_message: { ope: "<>", value: ""}}
                ]
            } 
        } ;
    }
    this.api.db.multiread(searches, function(err, reads){
        if(err){ return callback(err) ;}

        if(!data){
            data = {} ;
        }
        let baseUrl = reads.iz_global_settings.url ;
        let bannerUrl = "https://backoffice.ga-owork.fr/api/public/public_screen_html?screen_id=50" ;
        if(reads.iz_global_settings.banner_url){
            bannerUrl = reads.iz_global_settings.banner_url ;
        }
        if(bannerUrl){
            this.fetchPublicScreenBanner(bannerUrl);
        }
        var defaultDashboardSettings = { last_n_month : 12 };
        var userDashboardSettings = null;
        reads.iz_dashboard_global_settings.forEach(function(s){
            if(s.user_id){
                userDashboardSettings = s ;
            }else{
                defaultDashboardSettings = s ;
            }
        }) ;

        if (reads.iz_user_replace && reads.iz_user_replace.length > 0) {
            data.delegations = [] ;
            let names = [];
            let hasDelegGED = false;
            let hasDelegFAC = false;
            let linkGED = baseUrl+"#iz-docs$"+encodeURIComponent(JSON.stringify({replacedBy: this.api.currentUser.id}));;
            let linkFAC = baseUrl+"#dinvoice-main-supplier#iz-dinvoices-supplier$"+encodeURIComponent(JSON.stringify({replacedBy: this.api.currentUser.id}));

            reads.iz_user_replace.forEach(function(replace){
                !hasDelegGED ? hasDelegGED = replace.groups.some(group => group.model.name === "group_iz_doc_module_user") : null;
                !hasDelegFAC ? hasDelegFAC = replace.groups.some(group => group.model.name === "group_iz_dinvoice_supplier_user") : null;
                names.push(replace.user.name);
            }.bind(this)) ;

            names = names.reduce((acc, name, index) => {
                if (index === 0) { // No separator for the first name
                    return name;
                }
                if (index === names.length - 1) { // Use "and" (or "et" in french) separator for the last name
                    return acc + WebView.tr("userPrefs.nameSeparator") + name;
                }
                return acc + ", " + name; // Use normal separator
            }, "");

            if(hasDelegGED && hasDelegFAC){
                data.delegations.push({msg:WebView.tr("userPrefs.delegationBannerGEDandFAC", {delegator_name: names, linkGED, linkFAC})});
            } else if(hasDelegGED){
                data.delegations.push({msg:WebView.tr("userPrefs.delegationBannerGED", {delegator_name: names, linkGED})});
            } else if(hasDelegFAC){
                data.delegations.push({msg:WebView.tr("userPrefs.delegationBannerFAC", {delegator_name: names, linkFAC})});
            }

        }
        data.emailRecoveryError = [] ;

        if (reads.iz_doc_mail_server && reads.iz_doc_mail_server.length > 0) {
            let serversLinks = reads.iz_doc_mail_server.map(function (mailServer) {
                let id = mailServer.id;
                let name = mailServer.name || "";
                let linkConfig = baseUrl + "#iz-doc-mail-servers#!iz-doc-mail-server-form$" + id;
                return "<a href=\"" + linkConfig + "\">" + name + "</a>";
            });

            let serversLinksText = serversLinks.join(", ");
            data.emailRecoveryError.push({
                msg: WebView.tr("userPrefs.emailRecoveryErrorBanner", {
                    serversLinks: serversLinksText,
                    interpolation: { escapeValue: false }
                })
            });
        }

        userDashboardSettings = userDashboardSettings || defaultDashboardSettings ;

        var defaulWidgetSettings = {};
        var userWidgetSettings = {};
        reads.iz_dashboard_settings.forEach(function(s){
            if(s.user_id){
                userWidgetSettings[s.code] = s ;
            }else{
                defaulWidgetSettings[s.code] = s ;
            }
        }) ;



        Object.keys(defaulWidgetSettings).forEach(function(code){
            if(!userWidgetSettings[code]){
                userWidgetSettings[code] = defaulWidgetSettings[code] ;
            }else if(userWidgetSettings[code].size === "default"){
                userWidgetSettings[code].size = defaulWidgetSettings[code].size ;
            }
        }) ;

        //Get dashboards from modules (defined in registerModule)
        var dashboards = [] ;
        reads.iz_custom_screen.forEach(function(screen){
            var viewName = screen.table;
            if(screen.query){
                viewName = "x_v_"+screen.query.code.toLowerCase().replace(/[^a-z0-9_]/g, "_");
            }
            var search = null;
            if(screen.search_filter){
                try{
                    search = JSON.parse(screen.search_filter) ;
                }catch(err){
                    console.log("Error parsing dashboard search "+screen.search_filter) ;
                }
            }
            var intervalField = null;
            if(screen.dashboard_intervals.length === 0){
                intervalField = screen.dashboard_group_by ;
            }
            dashboards.push({
                position: 0, 
                name: screen.code+"_"+screen.id,
                label: screen.name,
                dashboardType: "timeInterval",
                groupBy: screen.dashboard_group_by,
                types: screen.dashboard_types,
                search: search,
                size: screen.dashboard_size,
                defaultSize: screen.dashboard_size,
                defaultType: screen.dashboard_default_type,
                intervals: screen.dashboard_intervals,
                defaultInterval: screen.dashboard_default_interval, 
                intervalField: intervalField,
                intervalLabelField: "name",
                table: viewName,
                timeField: screen.dashboard_time_field,
                ope: { ope: screen.dashboard_ope, column: screen.dashboard_ope_column },
            }) ;

        }) ;
        window.IZEE_MODULES.forEach(function(module){
            if(module.dashboards){
                const moduleDashboards = module.dashboards
                    .sort(function(d1, d2){
                        var d1Position = (d1.position||0);
                        var d2Position = (d2.position||0);
                        return d1Position - d2Position;
                    })
                    .map(function(d){
                        let baseSize = d.size || "small";
                        return {
                            ...d,
                            size: baseSize,
                            defaultSize: baseSize  
                        };
                    });

                dashboards = dashboards.concat(moduleDashboards);
            }
        }) ;
    

        var allDashboards = dashboards
        .filter(function(d){
            return !d.rights || this.api.currentUser.rights[d.rights] ;
        }.bind(this)) ;

        dashboards = allDashboards.filter(function(d){
            if(d.defaultSize == null){
                d.defaultSize = d.size ;
            }
            if ((d.size === "hidden" && !userWidgetSettings[d.name])) {
                return false;
            }

            if(userWidgetSettings[d.name] && userWidgetSettings[d.name].size === "default" && d.defaultSize === "hidden"){
                return false;
            }
            console.log(userWidgetSettings[d]) ;
            if(userWidgetSettings[d.name] && userWidgetSettings[d.name].size === "hidden"){
                // user setting is hidden
                return false;
            }
            return true ;
        }).sort(function(d1, d2){
            var d1Position = 9999 ;
            if(userWidgetSettings[d1.name]){
                d1Position = userWidgetSettings[d1.name].sequence ;
            }
            var d2Position = 9999 ;
            if(userWidgetSettings[d2.name]){
                d2Position = userWidgetSettings[d2.name].sequence ;
            }
            return d1Position - d2Position;
        }) ;
    
        
        var searchGroupByLabel = {} ;
    
        data.hasManyCompany = reads.res_company.length>1 ;
        data.userDashboardSettings = userDashboardSettings ;
        data.groupByLabels = {} ;
        // data.hasDelegation = reads.iz_user_replace.length>0 ;
    
        dashboards.forEach(function(dash){
            dash.id = "dashboard-"+WebView.uuid() ;
            
            if(!dash.size){
                dash.size = "small" ;
            }
            if(userWidgetSettings[dash.name] && userWidgetSettings[dash.name].size !== "default"){
                dash.size = userWidgetSettings[dash.name].size ;
            }
            if(!dash.controller){
                dash.loading = true ;
            }
            dash.classSize = "col-12 col-md-6 col-lg-4" ;
            if(dash.size === "medium"){
                dash.classSize = "col-12 col-md-12 col-lg-6" ;
            } else if(dash.size === "large"){
                dash.classSize = "col-12 col-md-12 col-lg-12" ;
            }
            if(dash.controller){
                dash.controllerInstance = new dash.controller() ;
                if(dash.controllerInstance.viewOptions && dash.controllerInstance.viewOptions.route){
                    dash.controllerInstance.viewOptions.route = null;
                    dash.controllerInstance.viewOptions.noRouting = true;
                }
                if(dash.controllerInstance.gridController){
                    dash.controllerInstance.gridController.viewOptions.route = null;
                    dash.controllerInstance.gridController.viewOptions.noRouting = true;
                }
                if(dash.controllerInstance.formController){
                    dash.controllerInstance.formController.viewOptions.route = null;
                    dash.controllerInstance.formController.viewOptions.noRouting = true;
                }
                window.app.registerController(dash.controllerInstance) ;
                return;
            }
            dash.interval = dash.interval||dash.defaultInterval ;
            dash.possibleIntervals = dash.intervals.map(function(interval){
                return {
                    value: interval,
                    label: WebView.tr("dashboard.interval."+interval)
                } ;
            });
            dash.type = dash.type||dash.defaultType ;
            dash.possibleTypes = dash.types.map(function(type){
                return {
                    value: type
                } ;
            });
    
            if(dash.groupBy){
                if(this.api.db.schema[dash.table].fk){
                    this.api.db.schema[dash.table].fk.some(function(col){
                        //{ "targetTable": "account_account", "thisColumn": "account_id", "targetColumn": "id" },
                        if(col.thisColumn === dash.groupBy){
                            searchGroupByLabel[dash.table+"."+dash.groupBy] = {
                                table: col.targetTable,
                                search: {}
                            } ;
                            return true ;
                        }
                    }) ;
                }
                this.api.db.schema[dash.table].columns.some(function(col){
                    if(col.name === dash.groupBy){
                        if(col.values && Array.isArray(col.values)){
                            col.values.forEach(function(v){
                                data.groupByLabels[dash.table+"."+dash.groupBy+"."+v] = WebView.tr("fields.values."+dash.table+"."+dash.groupBy+"."+v) ;
                            }) ;
                        }
                        return true ;
                    }
                }) ;
            }

            dash.showChartLabel = false;
            if(reads.iz_dashboard_global_settings[0]){
                dash.showChartLabel = reads.iz_dashboard_global_settings[0].show_chart_label ;
            };
    
        }.bind(this));
    
        data.dashboards = dashboards ;
        data.allDashboards = allDashboards ;
    
        /*if(Object.keys(searchGroupByLabel).length>0){
            this.api.db.multiread(searchGroupByLabel, function(err, reads){
                if(err){ return callback(err) ; }
    
                
    
                Object.keys(reads).forEach(function(k){
                    var table = k.split(".")[0];
                    var col = k.split(".")[1];
                    var labelField = "{{{name}}}" ;
                    this.api.db.schema[table].columns.some(function(c){
                        if(c.name === col){
                            if(c.labelField){
                                labelField = c.labelField ;
                            }
                            return true;
                        }
                    }) ;
                    if(labelField.indexOf("{{") === -1){
                        labelField = "{{{"+labelField+"}}}" ;
                    }
                    var templateLabel = Handlebars.compile(labelField);
                    reads[k].forEach(function(record){
                        var label = templateLabel(record); 
                        data.groupByLabels[k+"."+record.id] = label ;
                    }.bind(this)) ;
                }.bind(this)) ;

                callback(null, data) ;
                this.doCompute(data, data.dashboards) ;
            }.bind(this)) ;
        } else {
            callback(null, data) ;

            this.doCompute(data, data.dashboards) ;
        }*/
        data.displayLabel = true ;
        callback(null, data) ;
        this.doCompute(data, data.dashboards) ;
    }.bind(this)) ;

} ;

var COLORS = ["#A3B86B", "#1294BA", "#FF6E40", "#b39ddb", "#EF5350", "#AB47BC", "#3A00AE", 
    "#EC407A", "#7E57C2", "#42A5F5", "#5C6BC0", "#26A69A", "#29B6F6", "#26C6DA",
    "#66BB6A", "#D4E157", "#FFEE58", "#9CCC65", "#FFCA28", "#FF7043", "#FFA726",
    "#8D6E63"] ;

var COLORS_TEXT = ["#333333", "#333333", "#333333", "#333333", "#333333", "#333333", "#333333", 
    "#333333", "#333333", "#333333", "#333333", "#333333", "#333333", "#333333",
    "#333333", "#333333", "#333333", "#333333", "#333333", "#333333", "#333333",
    "#333333"] ;

if(window.app.context.isV2){
    COLORS = [ 
        "#23bdca", "#5d52b3", "#ff6b6b", "#4ecdc4", "#2b7f92ff", "#96ceb4", "#ffeaa7", "#dda0dd", 
        "#98d8c8", "#f7dc6f", "#bb8fce", "#85c1e9", "#f8c471", "#82e0aa", "#f1948a", "#d7bde2", 
        "#abebc6", "#fad7a0", "#d5a6bd", "#aed6f1", "#f9e79f"
    ] ; 
    COLORS_TEXT = [ 
        "#666666", "#999", "#666666", "#666666", "#999", "#666666","#666666","#666666",
        "#666666", "#666666", "#666666", "#666666", "#666666", "#666666", "#666666", "#666666", 
        "#666666", "#666666", "#666666", "#666666", "#666666"
    ] ; 
}

dashboardController.doCompute = function(data, dashboards, callback){
    if(!callback){
        callback = function(err){
            if(err){ return console.log(err) ; }
            this.view.render() ;
        }.bind(this) ;
    }
    if(!data){
        data = {} ;
    }
    if(!data.start || !data.end){
        var monthCount = data.userDashboardSettings.last_n_month || 12 ;
        data.start = moment().startOf("month").subtract(monthCount, "month").format("YYYY-MM-DD") ;
        data.end = moment().endOf("month").format("YYYY-MM-DD") ;
    }

    var promises = [] ;

    dashboards.forEach(function(dash){
        if(dash.controller){ return; }
        dash.loading = true ;
        var searches = {} ;
        var search = dash.search?JSON.parse(JSON.stringify(dash.search)):{} ;
        if(dash.timeField){
            search[dash.timeField] = { ope: "between", value: [data.start, data.end] } ;
        }

        if(data.company_id){
            let hasCompany = this.api.db.schema[dash.table].columns.some(function(col){ return col.name === "company_id" ; }) ;
            if(hasCompany){
                search.company_id = data.company_id ;
            }
        }

        var operations = {ope: dash.ope} ;
        if(dash.ope.ope || Array.isArray(dash.ope)){
            operations = dash.ope ;
        }

        var groupBy = [] ;
        if(dash.intervalField){
            groupBy.push({ field: dash.intervalField, dateTrunc: dash.interval||dash.defaultInterval }) ;
        }else{
            groupBy.push({ field: dash.timeField, dateTrunc: dash.interval||dash.defaultInterval }) ;
        }
        if(dash.groupBy){
            groupBy.push(dash.groupBy) ;
        }
        var orderBy = null;
        if(dash.orderBy){
            orderBy = dash.orderBy ;
        } else if(dash.groupBy){
            orderBy = dash.groupBy ;
        }
        searches[dash.name] = {
            table: dash.table,
            search : search,
            operations: operations,
            groupBy: groupBy,
            orderBy: orderBy
        } ;
        
        promises.push(new Promise(function(resolve){

            this.api.db.multiread(searches, function(err, reads){
                if(err){ 
                    dash.loading = false;
                    dash.error = err;
                    return resolve() ; 
                }
                dash.results = reads[dash.name] ;

                this.getIntervalFieldLabels(dash, dash.results, (err, intervalLabelById)=>{
                    if(err){ 
                        dash.loading = false;
                        dash.error = err;
                        return resolve() ; 
                    }
                    var intervalLabels = [] ;
                    var intervalIds = [] ;
                    var intervalDates = [] ;
                    var dataPerInterval = [] ;
                    var seriesNames = {} ;
                    var colors = [];
                    var colorsText = [];
    
                    if(dash.intervalField){
                        reads[dash.name].forEach(function(result){
    
                            var labelValue = result[dash.intervalField] ;
                            if(intervalLabelById[dash.table+"."+dash.intervalField]){
                                let l = intervalLabelById[dash.table+"."+dash.intervalField][result[dash.intervalField]] ; 
                                if(l){
                                    labelValue = l.name ;
                                    if(dash.intervalLabelField && typeof(dash.intervalLabelField) === "string"){
                                        labelValue = l[dash.intervalLabelField] ;
                                    }else if(dash.intervalLabelField && typeof(dash.intervalLabelField) === "function"){
                                        labelValue = dash.intervalLabelField(l) ;
                                    }
                                }
                            }else if(dash.intervalLabelField && typeof(dash.intervalLabelField) === "function"){
                                labelValue = dash.intervalLabelField(result) ;
                            }else{
                                let trKey = "fields.values."+dash.table+"."+dash.intervalField+"."+labelValue ;
                                let trLabel = WebView.tr(trKey) ;
                                if(trLabel !== trKey){
                                    labelValue = trLabel ;
                                }
                            }
                            if(labelValue === null || labelValue === undefined){
                                labelValue = dash.defaultLabel||WebView.tr("dashboard.noLabel") ;
                            }
                            console.log("label", labelValue) ;
                            var indexInterval = intervalLabels.indexOf(labelValue) ;
                            var thisIntervalData = {} ;
                            if(indexInterval === -1){
                                intervalIds.push(result[dash.intervalField]) ;
                                intervalLabels.push(labelValue) ;
                                if(!dash.groupBy){
                                    thisIntervalData.nogroup = 0 ;
                                }
                                dataPerInterval.push(thisIntervalData) ;
                            }else{
                                thisIntervalData = dataPerInterval[indexInterval] ;
                            }
                            var groupByValue = "nogroup" ;
                            if(dash.groupBy){
                                groupByValue = result[dash.groupBy] ;
                            }
                            if(seriesNames[groupByValue] == null){
                                seriesNames[groupByValue] = 0 ;
                                if(dash.getColor){
                                    colors.push(dash.getColor(groupByValue)) ;
                                }
                            }
                            if(!thisIntervalData[groupByValue]){
                                thisIntervalData[groupByValue] = 0 ;
                            }
                            var valCol = dash.ope ;
                            if(dash.ope.column){
                                valCol = dash.ope.column ;
                            }
    
                            seriesNames[groupByValue] += Number(result[valCol]) ;
                            thisIntervalData[groupByValue] += Number(result[valCol]) ;
                        }.bind(this)) ;
                    }else if(dash.interval){
                        var dt = moment(data.start).startOf(dash.interval) ;
                        var end = moment(data.end).endOf(dash.interval) ;
                        while(dt.isBefore(end)){
                            if(dash.interval === "month"){
                                intervalLabels.push(moment.localeData(WebView.i18n.getLang()).monthsShort()[dt.month()] + " "+dt.format("YYYY")) ;
                            } else if(dash.interval === "year"){
                                intervalLabels.push(dt.format("YYYY")) ;
                            } else if(dash.interval === "week"){
                                intervalLabels.push(moment(dt).startOf("week").format("DD/MM")+" - "+moment(dt).endOf("week").format("DD/MM")) ;
                            } else if(dash.interval === "day"){
                                intervalLabels.push(dt.format("DD/MM")) ;
                            }
                            
                            var intervalStart = dt;
                            var intervalEnd = moment(dt).add(1, dash.interval) ;
            
                            intervalDates.push({
                                start : intervalStart.format("YYYY-MM-DD"),
                                end : moment(intervalEnd).subtract(1, 'day').format("YYYY-MM-DD")
                            }) ;
                            
                            var thisIntervalData = {} ;
                            if(!dash.groupBy){
                                thisIntervalData.nogroup = 0 ;
                            }
                            dataPerInterval.push(thisIntervalData) ;
                            reads[dash.name].forEach(function(result){
                                var resultDt = moment(result[dash.timeField]) ;
                                var operations = [] ;
                                if(Array.isArray(dash.ope)){
                                    operations = dash.ope.map(function(o){
                                        return {
                                            column: o.column,
                                            serieCode: o.label||WebView.tr("fields."+dash.table+"."+o.column)
                                        } ;
                                    }) ;
                                }else if(dash.ope.column){
                                    operations = [{column: dash.ope.column, serieCode: "nogroup"}] ;
                                }else {
                                    operations = [{ column: dash.ope, serieCode: "nogroup" }] ;
                                }
                                operations.forEach(function(ope){
                                    var valCol = ope.column ;
                                    if(resultDt.isSameOrAfter(intervalStart) && resultDt.isBefore(intervalEnd)){
                                        var groupByValue = ope.serieCode ;
                                        if(dash.groupBy){
                                            groupByValue = result[dash.groupBy] ;
                                        }
                                        if(seriesNames[groupByValue] == null){
                                            if(dash.getColor){
                                                colors.push(dash.getColor(groupByValue)) ;
                                            }
                                            seriesNames[groupByValue] = 0 ;
                                        }
                                        if(!thisIntervalData[groupByValue]){
                                            thisIntervalData[groupByValue] = 0 ;
                                        }
                                        seriesNames[groupByValue] += Number(result[valCol]) ;
                                        thisIntervalData[groupByValue] += Number(result[valCol]) ;
                                    }
                                }.bind(this)) ;
                            }.bind(this)) ;
            
                            dt = intervalEnd;
                        }
                    }
                    if(colors.length === 0){
                        colors = dash.colors || COLORS;
                    }
                    if(colorsText.length === 0){
                        colorsText = dash.colorsText || COLORS_TEXT;
                    }
    
                    
                    dash.resultsByInterval = [] ;
                    dash.resultsTotal = [] ;
    
                    this.getGroupByLabels(dash, Object.keys(seriesNames), (err, groupByLabels)=>{
                        if(err){ 
                            dash.loading = false;
                            dash.error = err;
                            return resolve() ; 
                        }
    
                        Object.keys(seriesNames).forEach(function(serieName, index){
                            var serieLabel = serieName;
                            if(dash.groupBy && groupByLabels[dash.table+"."+dash.groupBy+"."+serieName]){
                                serieLabel = groupByLabels[dash.table+"."+dash.groupBy+"."+serieName] ;
                            }
                            if(serieLabel === "nogroup") {
                                serieLabel = dash.label ;
                            }
                            dash.resultsTotal.push({
                                name: serieLabel,
                                backgroundColor: colors[index],
                                textColor: colorsText[index]||"#AAAAAA",
                                value: seriesNames[serieName],
                                onClick: function(){
                                    if(dash.openOnClick){
                                        this.navigate("/"+dash.openOnClick
                                            .replace("{{intervalId}}", null)
                                            .replace("{{groupBy}}", serieName)
                                            .replace("{{start}}", moment(data.start).format("YYYY-MM-DD"))
                                            .replace("{{end}}", moment(data.end).format("YYYY-MM-DD"))
                                        ) ;
                                    }
                                }.bind(this)
                            }) ;
        
                            var onClicks = null;
                            if(dash.openOnClick || dash.onClick){
                                if(intervalDates.length>0){
                                    onClicks = intervalDates.map(function(dates){
                                        return function(){
                                            if(dash.onClick){
                                                dash.onClick({serieName, start: dates.start, end: dates.end}) ;
                                            }else if(dash.openOnClick){
                                                this.navigate("/"+dash.openOnClick
                                                    .replace("{{groupBy}}", serieName)
                                                    .replace("{{start}}", dates.start)
                                                    .replace("{{end}}", dates.end)
                                                ) ;
                                            }
                                        }.bind(this);
                                    }.bind(this)) ;
                                }else if(intervalIds.length>0){
                                    onClicks = intervalIds.map(function(intervalId){
                                        return function(){
                                            if(dash.onClick){
                                                dash.onClick({serieName, intervalId, start: data.start, end: data.end}) ;
                                            }else if(dash.openOnClick){
                                                this.navigate("/"+dash.openOnClick
                                                    .replace("{{groupBy}}", serieName)
                                                    .replace("{{intervalId}}", intervalId)
                                                    .replace("{{start}}", moment(data.start).format("YYYY-MM-DD"))
                                                    .replace("{{end}}", moment(data.end).format("YYYY-MM-DD"))
                                                ) ;
                                            }
                                        }.bind(this);
                                    }.bind(this)) ;
                                }
                            }
        
                            dash.resultsByInterval.push({
                                name: serieLabel,
                                backgroundColor: colors[index],
                                textColor: colorsText[index]||"#AAAAAA",
                                values: intervalLabels.map(function(monthLabel, i){
                                    return { name : monthLabel, value: dataPerInterval[i][serieName]||0} ;
                                }),
                                onClicks: onClicks
                            }) ;
                        }.bind(this)) ;
        
                        dash.loading = false;
                        return resolve() ; 
    
                    }) ;
                }) ;

                
            }.bind(this)) ;
        }.bind(this))) ;
    }.bind(this)) ;

    Promise.all(promises).then(function(){ return callback() ; }).catch(function(err){ return callback(err) ; }) ; 
} ;

dashboardController.getIntervalFieldLabels = function(dash, results, callback){
    let searchInterval = {} ;
    let intervalLabelById = {} ;

    if(dash.intervalField){
        if(this.api.db.schema[dash.table].fk){
            this.api.db.schema[dash.table].fk.some(function(col){
                //{ "targetTable": "account_account", "thisColumn": "account_id", "targetColumn": "id" },
                if(col.thisColumn === dash.intervalField){
                    intervalLabelById[dash.table+"."+dash.intervalField] = {} ;
                    let ids = results.map(r=>r[dash.intervalField]) ;
                    if(ids.length>0){
                        searchInterval[dash.table+"."+dash.intervalField] = {
                            table: col.targetTable,
                            search: { id: ids }
                        } ;
                    }
                    return true ;
                }
            }) ;
        }
    }
    if(Object.keys(searchInterval).length === 0){
        return callback(null, intervalLabelById) ; 
    }
    this.api.db.multiread(searchInterval, (err, reads)=>{
        if(err){ return callback(err) ; }
        Object.keys(reads).forEach(k=>{
            for(let r of reads[k]){
                intervalLabelById[k][r.id] = r ;
            }
        }) ;
        return callback(null, intervalLabelById) ; 
    });
};


dashboardController.getGroupByLabels = function(dash, ids, callback){
    if(ids.length === 0){
        return callback(null, {}) ;
    }
    if(dash.groupBy){
        if(dash.groupByLabels){
            return callback(null, dash.groupByLabels) ;
        }
        var groupByLabels = {} ;
        var searchGroupByLabel = {} ;
        if(this.api.db.schema[dash.table].fk){
            this.api.db.schema[dash.table].fk.some(function(col){
                //{ "targetTable": "account_account", "thisColumn": "account_id", "targetColumn": "id" },
                if(col.thisColumn === dash.groupBy){
                    searchGroupByLabel[dash.table+"."+dash.groupBy] = {
                        table: col.targetTable,
                        search: { id: ids.map(id=>Number(id)) }
                    } ;
                    return true ;
                }
            }) ;
        }
        this.api.db.schema[dash.table].columns.some(function(col){
            if(col.name === dash.groupBy){
                if(col.values && Array.isArray(col.values)){
                    col.values.forEach(function(v){
                        groupByLabels[dash.table+"."+dash.groupBy+"."+v] = WebView.tr("fields.values."+dash.table+"."+dash.groupBy+"."+v) ;
                    }) ;
                }
                return true ;
            }
        }) ;

        if(Object.keys(searchGroupByLabel).length>0){
            this.api.db.multiread(searchGroupByLabel, function(err, reads){
                if(err){ return callback(err) ; }
    
                Object.keys(reads).forEach(function(k){
                    var table = k.split(".")[0];
                    var col = k.split(".")[1];
                    var labelField = "{{{name}}}" ;
                    this.api.db.schema[table].columns.some(function(c){
                        if(c.name === col){
                            if(c.labelField){
                                labelField = c.labelField ;
                            }
                            return true;
                        }
                    }) ;
                    if(labelField.indexOf("{{") === -1){
                        labelField = "{{{"+labelField+"}}}" ;
                    }
                    var templateLabel = Handlebars.compile(labelField);
                    reads[k].forEach(function(record){
                        var label = templateLabel(record); 
                        groupByLabels[k+"."+record.id] = label ;
                    }.bind(this)) ;
                }.bind(this)) ;

                callback(null, groupByLabels) ;
            }.bind(this)) ;
        } else {
            callback(null, groupByLabels) ;
        }
    }else{
        callback(null, {}) ;
    }
} ;

dashboardController.onCompute = function(){
    this.view.updateData() ;
    this.doCompute(this.data, this.data.dashboards) ;
} ;

dashboardController.onRender = function(){
    this.view.ensureDisplayed(()=>{
        setTimeout(()=>{//delay a to not mix dash controller reads with others
            this.data.dashboards.filter(function(d){ return d.controller; }).forEach((dash)=>{
                var containerEl = this.view.viewRootEl.querySelector('[data-dash-id="'+dash.id+'"]');
                if(!containerEl){ return ; }
                (dash.controllerInstance.viewOptions || dash.controllerInstance.gridController.viewOptions
                    ).container = containerEl;
    
                dash.controllerInstance.view.options.container = containerEl ;
                dash.controllerInstance.view.container = containerEl ;
                dash.controllerInstance.view.customWaiter = true ;
                dash.controllerInstance.view._showWaiter = function(){
                    let dashContainer = containerEl.closest(".dashboard-block-container");
                    if(dashContainer){
                        dashContainer.classList.add("loading") ;
                    }
                };
                dash.controllerInstance.view._hideWaiter = function(){
                    let dashContainer = containerEl.closest(".dashboard-block-container");
                    if(dashContainer){
                        dashContainer.classList.remove("loading") ;
                    }
                };
                dash.controllerInstance.enter(this.data);
            }) ;
        }, 5) ;
    }) ;
} ;

dashboardController.onInterval = function(ev){
    var dashboard = ev.data.data ;
    this.view.updateData() ;
    this.view.longTask(function(done){
        this.doCompute(this.data, [dashboard], function(err){
            if(err){ return done(err) ;}
            ev.source.render() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

dashboardController.onChartType = function(ev){
    this.view.updateData() ;
    var dashboard = ev.data.parentData ;
    dashboard.type = ev.data.data.value ;
    ev.source.render() ;
} ;

dashboardController.onOpenSettings = function(){
    this.navigate("~dashboard-pref-popup") ;
} ;

dashboardController.softUnstack = function (data) {
    this.enter(data);
};

dashboardController.unstack = function(data) {
    this.emit("beforeUnstack") ;
    this.refresh(data, function(){
        this.view.show();
        this.emit("unstack") ;
    }.bind(this)) ;
};

dashboardController.fetchPublicScreenBanner = function(bannerUrl){
    let userId = this.api.currentUser.id;
    let keyHtml      = "dashboard_banner_html_"      + userId;
    let keyCollapsed = "dashboard_banner_collapsed_" + userId;
    let keyClosed    = "dashboard_banner_closed_"    + userId;
    fetch(bannerUrl)
        .then((response) => {
            if(response.ok){
                return response.text();
            }
            throw new Error("Banner fetch failed");
        })
        .then((html) => {
            if(html === "NOT_ACTIVE" || html === "NOT_FOUND"){
                throw new Error("Banner not active or not found");
            }
            let storedHtml = localStorage.getItem(keyHtml);
            let contentChanged = storedHtml !== html;
            if(contentChanged){
                // reset banner's state
                localStorage.setItem(keyHtml, html);
                localStorage.removeItem(keyClosed);
                localStorage.removeItem(keyCollapsed);
            }
            if(!contentChanged && localStorage.getItem(keyClosed) === "true"){
                this.data.showPublicBanner = false;
                return;
            }
            this.data.publicBannerHtml = html;
            this.data.showPublicBanner = true;
            let isCollapsed = !contentChanged && localStorage.getItem(keyCollapsed) === "true";
            this.data.publicBannerCollapsed = isCollapsed;
            this.view.render();
        })
        .catch(() => {
            this.data.showPublicBanner = false;
        });
};

dashboardController.onExpandBanner =
dashboardController.onToggleBanner = function(){
    let userId = this.api.currentUser.id;
    this.data.publicBannerCollapsed = !this.data.publicBannerCollapsed;
    localStorage.setItem("dashboard_banner_collapsed_" + userId, this.data.publicBannerCollapsed ? "true" : "false");
    let bannerContainer = this.view.container.querySelector(".public-banner-container") ;
    bannerContainer.classList.toggle("banner-collapsed");
    bannerContainer.classList.toggle("banner-expanded");
};

dashboardController.onCloseBanner = function(){
    let userId = this.api.currentUser.id;
    this.data.showPublicBanner = false;
    localStorage.setItem("dashboard_banner_closed_" + userId, "true");
    this.view.render();
};

module.exports = dashboardController ;